module.exports = __webpack_public_path__ + "static/pollution-c41d7872a5573bac27122bac5d43dc27.jpg";